import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addFieldData,
  removeStepChildren,
  setItemBreadcrumbs,
  setMessageWithCode,
  setReturnedValue,
  stopLoading
} from "../../actions";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from "@material-ui/core";
import { getConsigns, saveAppointment } from "../../utils/appointment";
import { translator } from "../../utils/i18n";
import { getPractitionerById } from "../../utils/practitioner";
import FormSearchList from "../FormSearchList";
import AlertDialog from "../AlertDialog";
import VideocamIcon from "@material-ui/icons/Videocam";
import { getAvailableAppointment } from "../../utils/scenario/scnr2-fetcher";
import Moment from "moment";
import AlertConsigns from "../AlertConsigns";
import { getReturnedValue } from "../../utils/fetcher";

class ListAppointment extends Component {
  state = {
    appointment: "",
    showMessage: false,
    consigns: [],
    fullAppointment: {}
  };
  originalActiveStep = {};

  componentDidMount() {
    this.originalActiveStep = { ...this.props.activeStep };
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    if (this.state.consigns.length === 0) {
      const nowDate = Moment().format("YYYY-MM-DD");
      getConsigns(
        getReturnedValue("appointmentType"),
        getReturnedValue("appointmentLocation"),
        nowDate,
        getReturnedValue("practitioner"),
        true
      ).then(consigns => {
        this.props.stopLoading();
        if (consigns && consigns.length > 0) {
          this.setState({
            consigns: consigns,
            fullAppointment: {}
          });
        }
      });
    }
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    this.props.removeStepChildren(this.originalActiveStep);
  }

  getData = () => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && stepData.formatSource) {
        data = stepData.formatSource(data);
      }
      return data;
    }
    return null;
  };

  handleAppointmentClick = async (event, appointment, date) => {
    this.setState({ showMessage: true });
    this.props.setMessageWithCodeFunc("");
    this.props.setReturnedValue({
      appointment: appointment.key,
      rdvHelp: appointment.rdvHelp
    });
    this.buildBreadcrumbs(date);
    const appointmentDate = Moment(appointment.date, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    getConsigns(
      appointment.appointmentTypeId,
      appointment.locationId,
      appointmentDate,
      appointment.practitionerId
    ).then(consigns => {
      this.props.stopLoading();
      if (consigns && consigns.length > 0) {
        this.setState({
          consigns: consigns,
          fullAppointment: appointment,
          appointment: appointment.key
        });
      } else {
        this.setState({ appointment: appointment.key });
        this.props.saveAppointment(appointment);
      }
    });
  };

  handleValidateConsigns = () => {
    this.setState({ consigns: [] });
    if (this.state.appointment !== "") {
      this.props.saveAppointment(this.state.fullAppointment);
    }
  };

  refreshList = () => {
    this.props.removeStepChildren(this.originalActiveStep);
    this.props.getAvailableAppointmentFunc();
  };

  onClickDialogAppointment = () => {
    this.refreshList();
    this.setState({ showMessage: false });
  };

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  getRenderItem = data => {
    const nbPeople = parseInt(this.props.returnedValue.nbPeople);
    let textPeople =
      nbPeople > 1
        ? `${translator()._("W_POUR")} ${nbPeople} ${translator()._(
            "W_STEP4_BAS_LIST_PERSONNES"
          )}`
        : "";

    const practitionerKnown = this.props.returnedValue.practitioner !== 0;
    return data.map(item => {
      let textSecondary = "";

      if (item.nomDocteurRefPrinc) {
        textSecondary = `${textPeople} 
        <strong class="color-red bold-normal">
          ${translator()._("CP_AVEC")} ${item.label} 
          ${
            item.nomDocteurRefPrinc
              ? translator()._("W_REMPLACANT") + " " + item.nomDocteurRefPrinc
              : ""
          }
        </strong>
        `;
      } else if (!practitionerKnown) {
        textSecondary = `${textPeople} 
        <strong class="color-black bold-normal normal-font-style">
          ${translator()._("CP_AVEC")} ${item.practitionerName} 
        </strong>
        `;
      }

      return (
        <ListItem
          button
          key={item.key}
          selected={this.state.appointment === item.key}
          className="wrap-line-select bottomBorder"
          onClick={event =>
            this.handleAppointmentClick(event, item, item.appointment)
          }
        >
          <ListItemText
            className="text"
            primary={item.appointment}
            secondary={
              <span dangerouslySetInnerHTML={{ __html: textSecondary }} />
            }
          />
          <ListItemAvatar>
            <Avatar
              alt={item.label}
              src={item.avatar}
              className="hoverAppear"
            />
          </ListItemAvatar>
        </ListItem>
      );
    });
  };

  getRenderItemAllPracticien = data => {
    const nbPeople = parseInt(this.props.returnedValue.nbPeople);
    let textPeople =
      nbPeople > 1
        ? `${translator()._("W_POUR")} ${nbPeople} ${translator()._(
            "W_STEP4_BAS_LIST_PERSONNES"
          )}`
        : "";

    return data.map(item => {
      let textSecondary = item.label
        ? item.nomDocteurRefPrinc
          ? textPeople +
            ' <strong class="color-red bold-normal">' +
            translator()._("CP_AVEC") +
            " " +
            item.label +
            " " +
            translator()._("W_REMPLACANT") +
            " " +
            item.nomDocteurRefPrinc +
            "</strong>"
          : textPeople + " " + translator()._("CP_AVEC") + " " + item.label
        : "";

      return (
        <ListItem
          button
          key={item.key}
          selected={this.state.appointment === item.key}
          onClick={event =>
            this.handleAppointmentClick(event, item, item.appointment)
          }
        >
          <ListItemAvatar>
            <Avatar alt={item.label} src={item.avatar} />
          </ListItemAvatar>
          <ListItemText
            className="text"
            primary={item.appointment}
            secondary={
              <span dangerouslySetInnerHTML={{ __html: textSecondary }} />
            }
          />
        </ListItem>
      );
    });
  };

  handleCloseConsigns = () => {
    this.setState({ consigns: [] });
    if (this.state.appointment !== "") {
      this.refreshList();
    }
  };

  render() {
    const { step } = this.props;
    const data = this.getData();
    const practitioner = this.props.returnedValue.practitioner || "";
    const getLabel = () => {
      if (!practitioner || practitioner === "0") {
        return step.label2 || "";
      }

      let practitionerName = "";
      if (data) {
        practitionerName = data[0].nomDocteurRefPrinc
          ? data[0].nomDocteurRefPrinc
          : data[0].label;
      } else {
        const practitionerDetails = getPractitionerById(practitioner);
        practitionerName = practitionerDetails
          ? practitionerDetails.libelle
          : "";
      }
      return (
        <React.Fragment>
          {step.label} <strong>{practitionerName}</strong>
        </React.Fragment>
      );
    };

    return (
      <>
        <div className="multiple-select-custom list-appointment">
          <label className="label">
            {step.icon && <img src={step.icon} alt={step.label} />}
            {getLabel()}
            {this.props.typeConsultation === "teleconsult" && (
              <VideocamIcon className="icon-video" />
            )}
          </label>
          {data && (
            <React.Fragment>
              {practitioner !== "0" && <List>{this.getRenderItem(data)}</List>}
              {practitioner === "0" && (
                <List>{this.getRenderItemAllPracticien(data)}</List>
              )}
            </React.Fragment>
          )}
          <FormSearchList />
        </div>
        {this.props.message && (
          <AlertDialog content={this.props.message} isResetAlert={true} />
        )}
        {this.props.messageWithCode &&
          this.props.messageWithCode.text &&
          this.state.showMessage && (
            <AlertDialog
              content={this.props.messageWithCode.text}
              onClick={this.onClickDialogAppointment}
              isResetAlert={false}
            />
          )}
        {this.state.consigns.length > 0 && (
          <AlertConsigns
            handleClose={() => this.handleCloseConsigns()}
            consigns={this.state.consigns}
            onClick={() => this.handleValidateConsigns()}
            noCancel={this.state.appointment === ""}
          />
        )}
      </>
    );
  }
}

ListAppointment.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  getAvailableAppointmentFunc: PropTypes.func,
  message: PropTypes.any,
  messageWithCode: PropTypes.shape({
    text: PropTypes.any
  }),
  removeStepChildren: PropTypes.func,
  resetData: PropTypes.func,
  returnedValue: PropTypes.shape({
    nbPeople: PropTypes.any,
    practitioner: PropTypes.string
  }),
  saveAppointment: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setMessageWithCodeFunc: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    label2: PropTypes.string
  }),
  typeConsultation: PropTypes.string,
  stopLoading: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    returnedValue: state.returnedValue,
    message: state.message,
    messageWithCode: state.messageWithCode,
    typeConsultation: state.returnedValue.typeConsultation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    saveAppointment: appointment => dispatch(saveAppointment(appointment)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    removeStepChildren: activeStep => dispatch(removeStepChildren(activeStep)),
    getAvailableAppointmentFunc: () => dispatch(getAvailableAppointment()),
    setMessageWithCodeFunc: message => dispatch(setMessageWithCode(message)),
    stopLoading: () => dispatch(stopLoading())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListAppointment);
